<div class="loading-backdrop" role="status" aria-label="Loading">
    <div class="loading-dots" aria-hidden="true">
        <span></span>
        <span></span>
        <span></span>
    </div>
</div>
